/* 🤖 this file was generated by svg-to-ts */
export const matIconCropRotate: {
  name: 'crop-rotate';
  data: string;
} = {
  name: 'crop-rotate',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8a2 2 0 0 0-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8a2 2 0 0 0 2 2h8v2h2v-2h2v-2H8z"/></svg>`
};
